<div fxLayout="row" fxLayoutAlign="center center" class="b-b">
    <h1 mat-dialog-title>Share MyCarePlan<sup>®</sup></h1>
</div>

<mat-dialog-content>
<form [formGroup]="shareForm">
    <div>
        <span><sup class="important">*</sup>For how long do you want to share?</span>
        <div fxLayout="row">
            <div>
                <mat-form-field>
                    <mat-select placeholder="day" name="duration" formControlName="duration">
                        <mat-option *ngFor="let item of days" [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div>
            <span class="text-muted">For your security, we only allow a maximum period of 30 days. After this period,
                this
                link expries and the access is removed.
            </span>
        </div>
    </div>

    <div class="m-t-10">
        <label><sup class="important">*</sup>Enter {{data.label}} of the recipient</label>
        <div>
            <mat-form-field appearance="outline">
                <input formControlName="medium" matInput placeholder="Enter {{data.label}}">
            </mat-form-field>
        </div>
    </div>

    <div>
        <label><sup class="important">*</sup>Message</label>
        <div>
            <mat-form-field appearance="outline">
                <textarea formControlName="message" matInput placeholder="I'd like to share my Care Plan with you."></textarea>
            </mat-form-field>
        </div>
    </div>
</form>
</mat-dialog-content>

<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
<mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button (click)="share()" mat-raised-button color="primary">Send</button>
</mat-dialog-actions>
</div>
